import { ApplicationConfig, importProvidersFrom, inject, isDevMode, provideEnvironmentInitializer, provideZoneChangeDetection, provideAppInitializer, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { YukawaConfirmationModule } from '@yukawa/chain-base-angular-comp/confirmation';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { IconService } from './service/icon.service';
import { InitModule, LocalStorageService, StorageService } from '@yukawa/chain-base-angular-client';
import { SessionModule } from '@yukawa/chain-main-angular-session';
import { YukawaAlertModule } from '@yukawa/chain-base-angular-comp/alert';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './service/transloco.http-loader';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AppInitializerService } from './service/app-initializer.service';
import { ThemeService } from './service/theme.service';
import { errorInterceptor } from './interceptors/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([errorInterceptor]), withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideEnvironmentInitializer(() => inject(IconService)),
    provideEnvironmentInitializer(() => inject(ThemeService)),
    provideAppInitializer(() => {
      const appInitializerService = inject(AppInitializerService);
      return appInitializerService.initialize();
    }),
    {
      provide: StorageService,
      useClass: LocalStorageService
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    {
      provide: LOCALE_ID,
      useFactory: () => {
        const translocoService = inject(TranslocoService);
        return translocoService.getActiveLang() || 'de';
      }
    },
    provideTransloco({
      config: {
        prodMode: !isDevMode(),
        availableLangs: [{ id: 'en', label: 'English' }, { id: 'de', label: 'Deutsch' }, { id: 'ru', label: 'Русский' }],
        defaultLang: 'en',
        fallbackLang: 'de',
        reRenderOnLangChange: true,
      },
      loader: TranslocoHttpLoader,
    }),
    importProvidersFrom(
      //add yukawa modules here if needed
      InitModule,
      SessionModule,
      YukawaConfirmationModule,
      YukawaAlertModule.forRoot({
        primary: 'check_circle',
        accent: 'check_circle',
        warn: 'warning',
        basic: 'check_circle',
        info: 'info',
        success: 'check_circle',
        warning: 'warning',
        error: 'error',
        dismiss: 'close',
      }),
    ),
    // {
    //   provide: SessionStoreServiceBase,
    //   useClass: SessionStoreService
    // },
  ],

};
